import React, { useState } from 'react';
import { developerInfo } from '../mock';
import { Mail, Linkedin, Github, Send, CheckCircle } from 'lucide-react';

const Contacts = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - in real app would send to backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <div className="page-container contacts-page">
      <div className="page-header">
        <h1 className="page-title">
          <span className="text-amber">[</span>
          GET_IN_TOUCH
          <span className="text-amber">]</span>
        </h1>
        <div className="ascii-line">
          {'━'.repeat(60)}
        </div>
        <p className="page-subtitle text-muted">
          # Let's connect and build something secure together
        </p>
      </div>

      <div className="contacts-content">
        <pre className="command-output">
{`$ nc -l gabriele.tita 3000
Listening for connections...
Connection established!
`}
        </pre>

        <div className="contacts-grid">
          <div className="contact-info">
            <h2 className="section-title">
              <span className="text-green">$</span> cat contact_info.txt
            </h2>

            <div className="info-cards">
              <a 
                href={`mailto:${developerInfo.email}`}
                className="contact-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="contact-icon">
                  <Mail size={32} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">EMAIL</div>
                  <div className="contact-value">{developerInfo.email}</div>
                </div>
              </a>

              <a 
                href={developerInfo.linkedin}
                className="contact-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="contact-icon">
                  <Linkedin size={32} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">LINKEDIN</div>
                  <div className="contact-value">gabriele-tita</div>
                </div>
              </a>

              <a 
                href={developerInfo.github}
                className="contact-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="contact-icon">
                  <Github size={32} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">GITHUB</div>
                  <div className="contact-value">titagram</div>
                </div>
              </a>
            </div>

            <div className="business-info">
              <h3 className="info-subtitle">
                <span className="text-cyan">&gt;</span> Business Information
              </h3>
              <div className="business-details">
                <div className="detail-line">
                  <span className="text-muted">Name:</span> {developerInfo.name}
                </div>
                <div className="detail-line">
                  <span className="text-muted">P.IVA:</span> {developerInfo.vat}
                </div>
                <div className="detail-line">
                  <span className="text-muted">Location:</span> {developerInfo.location}
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2 className="section-title">
              <span className="text-green">$</span> echo "message" &gt; /dev/contact
            </h2>

            {submitted ? (
              <div className="success-message">
                <CheckCircle size={48} className="success-icon" />
                <h3 className="success-title">Message Sent Successfully!</h3>
                <p className="success-text">
                  Thank you for reaching out. I'll get back to you soon.
                </p>
                <pre className="success-output">
{`$ sendmail --status
[OK] Message delivered successfully
[OK] Notification sent to inbox
[INFO] Expected response time: 24-48 hours`}
                </pre>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label className="form-label">
                    <span className="text-cyan">$</span> Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="John Doe"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <span className="text-cyan">$</span> Your Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="john@example.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <span className="text-cyan">$</span> Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Project inquiry / Collaboration / Question"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <span className="text-cyan">$</span> Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    placeholder="Enter your message here..."
                    rows="6"
                    required
                  />
                </div>

                <button type="submit" className="form-submit">
                  <Send size={20} />
                  <span>Send Message</span>
                </button>

                <div className="form-hint">
                  <span className="text-muted">
                    # This form is currently in demo mode. Use email link above for direct contact.
                  </span>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className="ascii-footer">
        <pre className="footer-art">
{`
╔════════════════════════════════════════════════════════════╗
║  "Talk is cheap. Show me the code." - Linus Torvalds    ║
╚════════════════════════════════════════════════════════════╝
`}
        </pre>
      </div>
    </div>
  );
};

export default Contacts;